"use client"

import { Layout, LayoutProps, theme } from "antd"
import { FC, RefAttributes } from "react"

const Header: FC<LayoutProps & RefAttributes<HTMLElement>> = ({ ...props }) => {
  const token = theme.useToken().token
  return (
    <Layout.Header {...props} />
  )
}

Header.displayName = 'Header'

export default Header